import React from 'react';
import { createUseStyles } from 'react-jss';
import { SelectHandle } from '../../../schema/interface';

const styles = createUseStyles({
    container: {},
    item: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '7px'
    },
    input: {
        margin: '0',
        marginInlineEnd: '7px',
        cursor: 'pointer',
        '&:disabled': {
            opacity: '1 !important'
        }
    },
    label: {
        cursor: 'pointer',
        maxWidth: '230px',
        display: ({ isBoolean }) => isBoolean && 'none'
    }
});

const Checkbox = ({
    options,
    name,
    selectedOptions,
    handleToggleOption,
    presentation,
    min,
    required,
    otherOptionValue,
    handleBlur,
    noAccess
}: SelectHandle) => {
    const classes = styles({ isBoolean: presentation.selectType === 2 });

    if (!options || !options.length) {
        return null;
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, el: HTMLElement) => {
        const value = e.target.value;
        handleToggleOption(value);
        setTimeout(() => {
            el.blur();
        }, 0);
    };

    return (
        <div className={classes.container}>
            {options.map((option: string[], index: number) => (
                <div className={classes.item} key={index}>
                    <input
                        className={classes.input}
                        type="checkbox"
                        name={name}
                        value={option[0]}
                        id={`${name}-${option[0]}`}
                        checked={!!selectedOptions?.find?.((val) => val[0] === option[0])}
                        onChange={(e) => {
                            const el = document.getElementById(`${name}-${option?.[0]}`);
                            onChange(e, el);
                        }}
                        required={
                            !selectedOptions?.length && (!!min || (required && !otherOptionValue))
                        }
                        disabled={noAccess}
                        onBlur={handleBlur}
                    />
                    <label className={classes.label} htmlFor={`${name}-${option[0]}`}>
                        {option[1]}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default Checkbox;
